export default __webpack_public_path__ + "static/media/project3.04c59b11.png";